export default __webpack_public_path__ + "static/media/history.a182f6a9.svg";